import React from 'react';
// @ts-ignore
import Config from 'Config';
import GTMScript from 'components/GTMScript';
import CoachingSelfServeView from 'coaching/components/CoachingSelfServeView/CoachingSelfServeView';
import CoachingStripeContainer from './components/CoachingStripeContainer';

export default function CoachingSelfServeContainer() {
  const hasOptOutExperiment = Config.Environment.COACHING_OPT_OUT_ENABLED === 'true';

  return (
    <React.Fragment>
      <GTMScript />
      <CoachingStripeContainer>
        <CoachingSelfServeView hasOptOutExperiment={hasOptOutExperiment} />
      </CoachingStripeContainer>
    </React.Fragment>
  );
}
